import { Badge, Card, Table, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { api } from '../../lib/api';
import { fmtDate, score } from '../../lib/format';
import type { MyCourse } from '../../lib/types';
import { PageHeader } from '../../ui/PageHeader';
import { QueryState } from '../../ui/QueryState';
import { StatusBadge } from '../../ui/StatusBadge';

export function HistoryPage() {
  const q = useQuery({ queryKey: ['my-courses'], queryFn: () => api.get<MyCourse[]>('/me/courses') });
  return (
    <>
      <PageHeader title="История обучения" subtitle="Все назначения: даты, итоговые баллы и версии курсов." />
      <QueryState loading={q.isLoading} error={q.error}>
        {() => (
          <Card withBorder radius="lg" p={0}>
            <Table.ScrollContainer minWidth={680}>
              <Table verticalSpacing="sm" horizontalSpacing="md" highlightOnHover>
                <Table.Thead>
                  <Table.Tr><Table.Th>Курс</Table.Th><Table.Th>Назначен</Table.Th><Table.Th>Статус</Table.Th><Table.Th>Завершён</Table.Th><Table.Th>Итоговый балл</Table.Th><Table.Th>Попытки</Table.Th></Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {[...q.data!].sort((x, y) => y.assignedAt.localeCompare(x.assignedAt)).map((a) => (
                    <Table.Tr key={a.id}>
                      <Table.Td><Text component={Link} to={`/learn/${a.id}`} fw={500} size="sm">{a.title}</Text><Badge size="xs" variant="outline" color="gray" ml={6}>v{a.version}</Badge></Table.Td>
                      <Table.Td><Text size="sm">{fmtDate(a.assignedAt)}</Text></Table.Td>
                      <Table.Td><StatusBadge status={a.status} /></Table.Td>
                      <Table.Td><Text size="sm">{fmtDate(a.completedAt)}</Text></Table.Td>
                      <Table.Td><Text size="sm" fw={600}>{score(a.passedCorrect ?? a.bestCorrect, a.questionCount)}</Text></Table.Td>
                      <Table.Td><Text size="sm">{a.attemptsUsed}</Text></Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
            </Table.ScrollContainer>
          </Card>
        )}
      </QueryState>
    </>
  );
}
